import React, { useState } from 'react'

import { images } from '../../constants'
import { AppWrap, MotionWrap } from '../../wrapper'
import { client } from '../../client'

import './Footer.scss'

const Footer = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' })
  const [isFormSubmitted, setIsFormSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)

  const { name, email, message } = formData;

  const handleChangeInput = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value })
  }

  const handleSubmit = () => {
    setLoading(true)

    const contact = {
      _type: 'contact',
      name: name,
      email: email,
      message: message
    }

    client.create(contact)
      .then(() => {
        setLoading(false)
        setIsFormSubmitted(true)
      })
  }

  return (
    <>
      <h2 className="head-text">Discutons autour d'un bon café</h2>

      <div className="app__footer-cards">
        <div className='app__footer-card'>
          <img src={images.email} alt="email" />
          <a href="mailto:greg.saimoen.12@gmail.com" className='p-text'>greg.saimoen.12@gmail.com</a>
        </div>
        <div className='app__footer-card'>
          <img src={images.mobile} alt="mobile" />
          <a href="tel: +687.83.87.83" className='p-text'>tel: +687.83.87.83</a>
        </div>
      </div>

      {!isFormSubmitted ?
      <div className="app__footer-form app__flex">
        <div className="app__flex">
          <input className="p-text" type='text' placeholder='Nom' name='name' value={name} onChange={handleChangeInput} />
        </div>
        <div className="app__flex">
          <input className="p-text" type='email' placeholder='E-mail' name='email' value={email} onChange={handleChangeInput} />
        </div>
        <div>
          <textarea className='p-text'
                    placeholder='Message'
                    name="message"
                    value={message}
                    onChange={handleChangeInput}></textarea>
        </div>
        <button type='button' className='p-text' onClick={handleSubmit}>{loading ? 'Message envoyé' : 'Envoyer'}</button>
      </div>
      :  <div>
  <h3 className="head-text">Merci pour votre attention!</h3>
</div>
}
    </>
  )
}

export default AppWrap(
  MotionWrap(Footer, 'app__footer'),
  'Contacts',
  'app__whitebg')